import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JackpotBetWidgetHighlightedTextDefaultBox} from "./jackpot-bet-widget-highlighted-text.default.box";
import {JackpotBetWidgetHighlightedTextMRGBox} from "./jackpot-bet-widget-highlighted-text.mrgreen.box";
import {JackpotBetWidgetHighlightedText777Box} from "./jackpot-bet-widget-highlighted-text.777.box";


export const JackpotBetWidgetHighlightedTextBox = styledByTheme(JackpotBetWidgetHighlightedTextDefaultBox)
    .forMrGreen(JackpotBetWidgetHighlightedTextMRGBox)
    .forCasino777(JackpotBetWidgetHighlightedText777Box)
    .apply();